"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIconSmall = CloseIconSmall;
exports.default = CloseIcon;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireWildcard(require("./shared/icon-base"));

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CloseIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 5l14 14m0-14L5 19"
  }));
}

function CloseIconSmall(props) {
  return (0, _core.jsx)(_iconBase.default, _extends({
    size: "small",
    viewBox: _iconBase.SMALL_VIEWBOX
  }, props), (0, _core.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 5l8 8M5 13l8-8"
  }));
}